import { render, staticRenderFns } from "./ViqConversationList.vue?vue&type=template&id=7b7d0ffa&scoped=true"
import script from "./ViqConversationList.vue?vue&type=script&lang=js"
export * from "./ViqConversationList.vue?vue&type=script&lang=js"
import style0 from "./ViqConversationList.vue?vue&type=style&index=0&id=7b7d0ffa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d0ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b7d0ffa')) {
      api.createRecord('7b7d0ffa', component.options)
    } else {
      api.reload('7b7d0ffa', component.options)
    }
    module.hot.accept("./ViqConversationList.vue?vue&type=template&id=7b7d0ffa&scoped=true", function () {
      api.rerender('7b7d0ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqConversationList.vue"
export default component.exports